import { render, staticRenderFns } from "./cardbalanceDetail.vue?vue&type=template&id=5f6371e6&scoped=true&"
import script from "./cardbalanceDetail.vue?vue&type=script&lang=js&"
export * from "./cardbalanceDetail.vue?vue&type=script&lang=js&"
import style0 from "./cardbalanceDetail.vue?vue&type=style&index=0&id=5f6371e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6371e6",
  null
  
)

export default component.exports